import Cookies from 'js-cookie'

const TokenKey = 'smartnumeralone-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

// 登录验证工具函数
export const checkAuth = () => {
  const token = localStorage.getItem('auth_token');
  const loginTime = localStorage.getItem('login_time');
  
  if (!token || !loginTime) {
    return false;
  }
  
  // 检查token是否过期（可选：设置24小时过期）
  const now = Date.now();
  const loginTimestamp = parseInt(loginTime);
  const expirationTime = 24 * 60 * 60 * 1000; // 24小时
  
  if (now - loginTimestamp > expirationTime) {
    // token过期，清除存储
    localStorage.removeItem('auth_token');
    localStorage.removeItem('login_time');
    return false;
  }
  
  return true;
};

// 登出函数
export const logout = () => {
  localStorage.removeItem('auth_token');
  localStorage.removeItem('login_time');
};

// 获取token
export const getAuthToken = () => {
  return localStorage.getItem('auth_token');
};
